import { IconButton, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { ScrollView, Text } from 'native-base';
import React from 'react';
import { StyleSheet } from 'react-native';

import { Button } from './components/Button';
import { Container } from './components/Container';
import { Input } from './components/Input';
import { Message } from './components/Message';
import { SenderType, useChat } from './hooks/chat';

interface ChatProps {}

export const Chat: React.FC<ChatProps> = () => {
  const {
    messages,
    handleSendMessage,
    input,
    onChangeSetInput,
    chatContainerRef,
    messageIsSending,
    onToggleChatState,
    chatIsOpen,
    sendButtonIsDisabled,
    animatedWidth,
    isHovered,
    onHoverIn,
    onHoverOut,
  } = useChat();

  if (!chatIsOpen) {
    return (
      <Button
        {...{
          onToggleChatState,
          animatedWidth,
          isHovered,
          onHoverIn,
          onHoverOut,
        }}
      />
    );
  }

  return (
    <Container borderRadius={BoxRadius.sm}>
      <VStack
        justifyContent="space-between"
        bg="neutral.white"
        flex={1}
        borderRadius={BoxRadius.sm}>
        <HStack
          p={Spacing['inline.xxxs']}
          alignItems="center"
          w="full"
          borderTopRadius={BoxRadius.sm}
          justifyContent="space-between"
          bg={Color['brand.tertiary.principal']}>
          <Text variant="semibold" fontSize={Typography['fontsize.lg']} color="white">
            Gê
          </Text>
          <IconButton
            onPress={onToggleChatState}
            icon="Close"
            p={0}
            iconSize="xxxs"
            testId="back"
            iconColor={Color['neutral.white']}
          />
        </HStack>
        <ScrollView
          showsVerticalScrollIndicator={false}
          h="370px"
          contentContainerStyle={styles.contentContainer}
          ref={chatContainerRef}>
          {messages.map((message, index) => (
            <Message
              key={index.toString()}
              sender={message.sender as SenderType}
              text={message.text}
            />
          ))}
        </ScrollView>
        <Input
          {...{
            handleSendMessage,
            input,
            onChangeSetInput,
            messageIsSending,
            sendButtonIsDisabled,
          }}
        />
      </VStack>
    </Container>
  );
};

const styles = StyleSheet.create({
  contentContainer: {
    padding: Utils.Token.ToInt(Spacing, 'inline.xxxs'),
    rowGap: Utils.Token.ToInt(Spacing, 'stack.xxs'),
  },
});
